<template>
  <v-navigation-drawer
    v-model="drawel"
    :mini-variant="globalConfig.navigation.mini"
    color="#F6F5F5"
    permanent
    app
  >
    <v-list dense nav class="py-0">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar>
          <img
            :src="user.picture"
            alt="User picture"
            referrerpolicy="no-referrer"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ user.name }}</v-list-item-title>
          <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />
      <v-list-item link @click="changeMiniVisualization">
        <v-list-item-icon>
          <v-icon v-if="globalConfig.navigation.mini">mdi-arrow-right</v-icon>
          <v-icon v-else>mdi-arrow-left</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Minify</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />

      <div v-for="item in items" :key="item.title">
        <v-list-item
          link
          v-if="!item.children || item.children.length === 0"
          @click="item.href ? handleRouteChange(item.href) : item.action()"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-else
          :prepend-icon="item.icon"
          :value="false"
          @click="item.href ? handleRouteChange(item.href) : item.action()"
        >
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <v-list-item
            class="ml-3"
            link
            v-for="child in item.children"
            :key="child.title"
            @click="child.href ? handleRouteChange(child.href) : child.action()"
          >
            <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { GlobalConfig } from '@/shared/GlobalAppconfig.class';
import { LocalStorageService, AuthService } from '@/services';

export default {
  data() {
    return {
      globalConfig: GlobalConfig.config,
      drawel: true,
      items: [
        { title: 'Tasks', icon: 'mdi-pentagon', href: '/home/tasks' },
        { title: 'Users', icon: 'mdi-account-multiple', href: '/home/users' },
        { title: 'Files', icon: 'mdi-file-multiple', href: '/home/uploads' },
        { title: 'Admin', icon: 'mdi-cogs', href: '/admin' },
        {
          title: 'Log out',
          icon: 'mdi-exit-to-app',
          action: () => {
            AuthService.logOut();
            this.$router.replace('/');
          }
        }
      ],
      color: 'primary',
      right: false,
      miniVariant: false,
      expandOnHover: false,
      user: LocalStorageService.get('user')
    };
  },
  computed: {},
  methods: {
    changeMiniVisualization() {
      GlobalConfig.config.navigation.mini =
        !GlobalConfig.config.navigation.mini;
      this.globalConfig = GlobalConfig.config;
    },
    handleRouteChange(path) {
      const { path: routePath } = this.$route;

      if (routePath !== path) {
        this.$router.push({ path });
      }
    }
  }
};
</script>
